//https://blog.logrocket.com/simplify-react-state-management-with-hookstate/
import { hookstate } from '@hookstate/core'

const globalLogStore = hookstate({
    showContactUs: false
});

export default globalLogStore;